import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Only register service worker in production or if explicitly enabled
const shouldEnableServiceWorker = 
  process.env.REACT_APP_ENABLE_SERVICE_WORKER === 'true' || 
  (process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENABLE_SERVICE_WORKER !== 'false');

if (shouldEnableServiceWorker) {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      window.dispatchEvent(new CustomEvent('sw-update-available', { detail: registration }));
    }
  });
} else {
  serviceWorkerRegistration.unregister();
  console.log('Service Worker is disabled');
}
